module.exports = __webpack_public_path__ + "img/2024112902.ff29eb9e.png";